import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import Button from "../../../shared/components/Button/Button";

import Appointments from "../Appointments/Appointments";
import DoctorsNearby from "../DoctorsNearby/DoctorsNearby";
import ExpenseReport from "../ExpenseReports/ExpenseReports";
import HealthReport from "../HealthReport/HealthReport";
import PatientDetails from "../PatientDetails/PatientDetails";
import PatientProfile from "../PatientProfile/PatientProfile";
import Backicon from "../../../shared/components/Backicon/Backicon";
import patientstyles from "./patientregister.module.css";

const initialState = {
  Name: "",
  Email: "",
  Address: "",
  Password: "",
  NameError: "",
  EmailError: "",
  AddressError: "",
  PasswordError: "",
  isLogin: true,
};

class PatientRegister extends Component {
  state = initialState;

  change = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  validate = () => {
    let NameError = "";
    let EmailError = "";
    let AddressError = "";
    let PasswordError = "";

    if (!this.state.Name) {
      NameError = "Invalid Name";
    }

    if (!this.state.Email.includes("@")) {
      EmailError = "Invalid Email";
    }

    if (!this.state.Address) {
      AddressError = "Address Cannot Be Empty";
    }

    if (this.state.Password.length < 8) {
      PasswordError = "Need a strong Password";
    }

    if (EmailError || NameError || AddressError || PasswordError) {
      this.setState({ EmailError, NameError, AddressError, PasswordError });
      return false;
    }
    return true;
  };

  onSubmit = (e) => {
    e.preventDefault();
    const isValid = this.validate();
    if (isValid) {
      console.log(this.state);

      const patient_register = {
        Name: this.state.Name,
        Email: this.state.Email,
        Address: this.state.Address,
        Password: this.state.Password,
      };
      localStorage.setItem(
        "patient_login_signup",
        JSON.stringify(patient_register)
      );
      this.setState(initialState);
    }
    this.props.history.push("/patient/patient-profile");
  };

  render() {
    return (
      <>
        <div className={patientstyles.content}>
          <div className={patientstyles.pregbanner}>
            <Backicon onClick={() => this.props.history.goBack()} />
            <h1>
              Patient <br /> register
            </h1>
          </div>
          <div className={patientstyles.signInStyles}>
            <div>
              <div className={patientstyles.regbuttons}>
                <button onClick={() => this.setState({ isLogin: true })}>
                  Login
                </button>
                <button onClick={() => this.setState({ isLogin: false })}>
                  Sign Up{" "}
                </button>
              </div>
              <form className={patientstyles.signupbtn}>
                {!this.state.isLogin && (
                  <>
                    <input
                      name="Name"
                      placeholder={"Name"}
                      value={this.state.Name}
                      onChange={(e) => this.change(e)}
                    />
                    {this.state.NameError ? (
                      <div className={patientstyles.error}>
                        {this.state.NameError}
                      </div>
                    ) : null}
                    <br />
                  </>
                )}

                <input
                  name="Email"
                  placeholder="Email"
                  value={this.state.Email}
                  onChange={(e) => this.change(e)}
                />
                {this.state.EmailError ? (
                  <div className={patientstyles.error}>
                    {this.state.EmailError}
                  </div>
                ) : null}
                <br />

                {!this.state.isLogin && (
                  <>
                    <textarea
                      name="Address"
                      placeholder="Address"
                      value={this.state.Address}
                      onChange={(e) => this.change(e)}
                    />
                    {this.state.AddressError ? (
                      <div className={patientstyles.error}>
                        {this.state.AddressError}
                      </div>
                    ) : null}
                    <br />
                  </>
                )}

                <input
                  name="Password"
                  type="password"
                  placeholder="Password"
                  value={this.state.Password}
                  onChange={(e) => this.change(e)}
                />
                {this.state.PasswordError ? (
                  <div className={patientstyles.error}>
                    {this.state.PasswordError}
                  </div>
                ) : null}
                <div className={patientstyles.submitButton}>
                  <Button
                    onClick={(e) => this.onSubmit(e)}
                    buttonName={this.state.isLogin ? "Log in" : "sign up"}
                    style={{
                      color: "white",
                      width: "260px",
                      margin: "20px 30px",
                    }}
                  ></Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function PatientRoutes() {
  return (
    <Switch>
      <Route path="/patient" exact component={PatientRegister} />
      <Route path="/patient/patient-profile" exact component={PatientProfile} />
      <Route path="/patient/patient-details" component={PatientDetails} />
      <Route path="/patient/doctors-nearby" component={DoctorsNearby} />
      <Route path="/patient/appointments" component={Appointments} />
      <Route path="/patient/health-reports" component={HealthReport} />
      <Route path="/patient/expense-report" component={ExpenseReport} />
    </Switch>
  );
}

export default PatientRoutes;
